import { NGXLogger } from 'ngx-logger';
import { Injectable } from '@angular/core';
import { ConfigService } from './config/config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { GestioneLoginService } from 'src/app/servizi/login/gestione-login.service';
import { HttpHeaders } from '@angular/common/http';

interface HttpOptionsInterface {
   headers?: HttpHeaders | {
      [header: string]: string | string[];
   };
   observe?: "body";
   body?: any,
   params?: HttpParams | {
      [param: string]: string | string[];
   };
   reportProgress?: boolean;
   responseType?: any;
   withCredentials?: boolean;
};

/**
 * Servizio contenente funzioni generali condivise dall'intero portale
 */
@Injectable({
   providedIn: 'root',
})
export class UtilsService {
   /** Chiave utilizzata nel file JSON che contiene tutte le rotte di una API */
   private static PATHS_KEY: string = 'paths';

   /** Indirizzo del server backend */
   private configServerIP: string;

   /** Porta del server backend */
   private configServerPort: any;

   /** Porta del server backend */
   private configServerProtocol: string;

   /** Porta del server backend */
   private configServerRelativePath: string;

   /** costruttore */
   constructor(
      private http: HttpClient,
      private configService: ConfigService,
      private logger: NGXLogger,
      private loginServ: GestioneLoginService
   ) {
      // inizializzo i parametri di connessione al server
      this.configServerIP = this.configService.getConfigGlobale().api.server.apiIp;
      this.configServerPort = this.configService.getConfigGlobale().api.server.apiPort;
      this.configServerProtocol = this.configService.getConfigGlobale().api.server.apiProtocol;
      this.configServerRelativePath = this.configService.getConfigGlobale().api.server.apiRelativePath;
   }

   /**
    * Utile nelle procedure di filtro. Converte i null in stringa
    * e rende tutto maiuscolo, in modo da unificare i confronti
    * @param {string} str stringa da convertire
    * @returns {string} stringa convertita
    */
   nullToString(str: string): string {
      if (str == null) {
         return '';
      } else {
         return str.toUpperCase();
      }
   }

   /**
    * generatore di URL per raggiungere il backend
    * @param sezione sezione del file di configurazione (campo key del campo routes)
    * @param id identificativo della rotta (campo id del paths)
    * @returns URL completo
    */
   creaURL(sezione: string, id: string) {
      try {
         const path: string = this.configService.getConfigGlobale().api.routes.find(r => r.key === sezione)[UtilsService.PATHS_KEY].find(p => p.id === id).path;

         if (this.configServerRelativePath) {
            return this.configServerRelativePath + path;
         } else {
            const serverAddress: string = this.configServerProtocol + this.configServerIP;
            const routeAddress: string = this.configService.getConfigGlobale().api.routes.find(r => r.key === sezione)['routeIp'];
            const pathAddress: string = this.configService.getConfigGlobale().api.routes.find(r => r.key === sezione)[UtilsService.PATHS_KEY].find(p => p.id === id).pathIp;
            const serverPort: number = this.configServerPort;
            const routePort: number = this.configService.getConfigGlobale().api.routes.find(r => r.key === sezione)['routePort'];
            const pathPort: number = this.configService.getConfigGlobale().api.routes.find(r => r.key === sezione)[UtilsService.PATHS_KEY].find(p => p.id === id).pathPort;

            // Addresses and ports have a priority order: from single path to server.
            const address: string = pathAddress ? pathAddress : routeAddress ? routeAddress : serverAddress;
            const port: number = pathPort ? pathPort : routePort ? routePort : serverPort;

            return address + ":" + port + path;
         }
      } catch {
         this.logger.error(
            `Impossibile Generare il path ${sezione}/${id}. Controllare in ../assets/config/config-globale.dev.json`
         );
         return '';
      }
   }

   /**Content-Type
    * Metodo per ricavare tutte le rotte di una API identificata dalla sezione
    * @param sezione API di cui si vogliono ottenere le rotte
    * @returns array contenente tutte le rotte di una specifica API
    */
   ottieniTutteRoutes(
      sezione: string
   ): [
         {
            /** identificativo route */
            id: string;
            /** percorso della route */
            path: string;
         }
      ] {
      return this.configService
         .getConfigGlobale()
         .api.routes.find((r) => r.key === sezione)[UtilsService.PATHS_KEY];
   }

   /**
    * Metodo per generare l'url del back avendo già la rotta desiderata
    * @param route rotta da utilizzare per creare l'URL
    */
   creaUrlDaRoute(route: string): string {
      if (this.configServerRelativePath) {
         return this.configServerRelativePath + route;
      } else {
         return (
            this.configServerProtocol +
            this.configServerIP +
            ':' +
            this.configServerPort +
            route
         );
      }
   }

   /**
    * Metodo per effettaure una select generica sul DB
    * @param params es: { "corpo": "* FROM pippo" }
    */
   queryView(params: any): any {
      const API_URL = this.creaURL('query', 'view');

      return this.http
         .post(API_URL, params, this.getAuthorizationHeader())
         .pipe(
            map((resp: any) => {
               if (resp.error === 0) {
                  return resp.data;
               } else {
                  this.logger.error(`Errore getTable`, resp);
                  return undefined;
               }
            })
         )
         .pipe(
            catchError((error) => {
               return throwError(error);
            })
         );
   }


   // ------------------------------------------------------------------------------------------

   // Microsoft Azure AD SSO
   private getAuthorizationHeader(content_type?: string) {
      let headers = new HttpHeaders({
         Authorization: 'Bearer ' + this.loginServ.getToken(),
      });

      if (content_type && content_type !== 'FILE') {
         headers = headers.append('Content-Type', content_type);
      } else if (!content_type) {
         headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
      }

      return { headers };
   }

   // ------------------------------------------------------------------------------------------

   /**
    * Metodo per effettaure una generica richiesta in post al backend
    * @param url url da chiamare. es: this.creaURL('soggetti', 'save')
    * @param params parametri della richiesta. es: { "soggetto": {...} }
    */
   simplepostRequest1(url: string, params: any): any {
      return this.http.post(url, params);
   }

   /**
    * Utile nei selettori TypeHead di ng-bootstrap per filtrare gli elementi di un array
    * in base al testo digitato dall'utente
    * @param {string} term stringa digitata
    * @param {any[]} array array sorgente da filtrare
    * @param {func()} formatter funzione di prelevamento stringa
    * @param {number} limit numero di elementi da mostrare
    * @returns {any[]} array filtrato, ordinato e limitato
    */
   searchFilterTH(term: string, array: any[], formatter: any, limit: number): string[] {
      return array
         .filter((e) => formatter(e).toLowerCase().includes(term.toLowerCase()))
         .sort(
            (a, b) =>
               formatter(a).toLowerCase().indexOf(term.toLowerCase()) -
               formatter(b).toLowerCase().indexOf(term.toLowerCase())
         )
         .slice(0, limit);
   }

   /**
    * Questo metodo è utile per formattare una data da stringa al tipo richiesto dal
    * componente ngbDatepicker
    * @param val :string valore della data
    */
   _dataFormatter(val) {

      if (!val || typeof val !== 'string') { return; }

      let [year, month, day] = [null, null, null];

      if (!val) {

         return { year, month, day };
      }

      const controlloAnno: RegExp = /^[0-9]{4}?/;
      const lang = controlloAnno.test(val) ? 'eng' : 'ita';
      if (lang === 'ita') {
         [day, month, year] = val.split('/');
      } else {
         [year, month, day] = val.split('-');
      }

      const a = {
         year: parseInt(year),
         month: parseInt(month),
         day: parseInt(day),
      };

      return a;
   }

   /**
    *
    * @param name
    */
   getFunctionPageId(name: string): number {
      const func = null
      // const func = this.configService
      //    .getConfigGlobale()
      //    .funzionalita.find((x) => x.nome === name);
      return func ? func.id : 0;
   }


   /**
    * Function to make a GET request to the backend
    * @param url eg: this.creaURL('user', 'get')
    * @param parameters Parameters. es: { ids:[1,2,3] }
    */
   getRequest(url: string,
      parameters: { [param: string]: readonly (string | number | boolean)[] | string | number | boolean | (string | string[])[]; },
      httpOptions?: HttpOptionsInterface): Observable<any> {
      let params = this.createHttpParameters(parameters);
      const opt = { ...httpOptions, ...this.getAuthorizationHeader(), params: params };

      return this.http.get(url, opt)
         .pipe(
            map((resp: any) => {

               if (resp.error && resp.error !== 0) {
                  this.logger.error(`GET Request Error`, resp);
               }

               return resp;
            })
         )
         .pipe(
            catchError((error) => {
               return throwError(error);
            })
         );
   }


   private createHttpParameters(parameters: { [param: string]: readonly (string | number | boolean)[] | string | number | boolean | (string | string[])[]; }): HttpParams {
      let params = new HttpParams();

      for (const key in parameters) {
         if (parameters[key] != undefined && parameters[key] != null) {
            if (Array.isArray(parameters[key])) {
               params = params.set(key, (parameters[key] as readonly (string | number | boolean)[]).join());
            } else if ((typeof parameters[key] === 'string' || typeof parameters[key] === 'number' || typeof parameters[key] === 'boolean')) {
               params = params.set(key, (parameters[key] as string))
            }
         }
      }
      return params;
   }


   // ------------------------------------------------------------------------------------------
   // Microsoft Azure AD SSO

   /**
    * @param url url da chiamare. es: this.creaURL('soggetti', 'save')
    * @param body body della richiesta. es: { "soggetto": {...} }
    * @param serialize Whether or not to serialize the whole request in a string.
    * @param httpOptions HttpOptionsInterface della richiesta.
    * @returns Observable<unknown>
    */
   postRequest(url: string, body: any, serialize = true, httpOptions?: HttpOptionsInterface): Observable<unknown> {

      const opt = { ...httpOptions, ...this.getAuthorizationHeader() };

      const params = serialize ? new HttpParams()
         .set('serialized', JSON.stringify(body)).toString() : body;

      return this.http.post(url, params, opt)
         .pipe(
            map((resp: any) => {

               if (resp.error && resp.error !== 0) {
                  this.logger.error(`Errore postRequest`, resp);
               }

               return resp;
            })
         )
         .pipe(
            catchError((error) => {
               return throwError(error);
            })
         );
   }

   // ------------------------------------------------------------------------------------------

   /**
    * Metodo per effettaure una generica richiesta in put al backend
    * @param url url da chiamare. es: this.creaURL('soggetti', 'save')
    * @param body body della richiesta. es: { "soggetto": {...} }
    * @param httpOptions httpOtions della richiesta.
    */
   putRequest(url: string, body: any, httpOptions?: HttpOptionsInterface): Observable<unknown> {

      const params = new HttpParams()
         .set('serialized', JSON.stringify(body))

      const opt = { ...httpOptions, ...this.getAuthorizationHeader() };


      return this.http.put(url, params.toString(), opt)
         .pipe(
            map((resp: any) => {
               // in caso di errore stampo un alert
               if (resp.error && resp.error !== 0) {
                  this.logger.error(`Errore postRequest`, resp);
               }

               // in ogni caso ritorno al response dell'API
               return resp;
            })
         )
         .pipe(
            catchError((error) => {
               return throwError(error);
            })
         );
   }

   /**
    * Metodo per effettaure una generica richiesta in post al backend   'Content-Type': 'multipart/form-data'
    * @param url url da chiamare. es: this.creaURL('soggetti', 'save')
    * @param params parametri della richiesta. es: { "soggetto": {...} }
    */
   postRequestFormData(url: string, params: any, content_type?: string): Observable<any> {

      const opt = { ...{}, ...this.getAuthorizationHeader(content_type), };

      return this.http.post(url, params, opt)
         .pipe(
            map((resp: any) => {

               // Error
               if (resp.error && resp.error !== 0) {
                  console.log(`Errore postRequest`, resp);
               }

               // Returns the response
               return resp;
            })
         )
         .pipe(
            catchError((error) => {
               return throwError(error);
            })
         );
   }


   postRequestFormDataXml(url: string, params: any): Observable<any> {

      const headers = new HttpHeaders()
         .set('responseType', 'text');

      return this.http
         .post(url, params, {
            headers
         })
         .pipe(
            map((resp: any) => {
               // in caso di errore stampo un alert
               if ((resp.error && resp.error !== 0) || (resp.status && resp.status !== 0)) {
                  this.logger.error(`Errore postRequest`, resp);
               }

               // in ogni caso ritorno al response dell'API
               return resp;
            })
         )
         .pipe(
            catchError((error) => {
               return throwError(error);
            })
         );
   }

   /**
    *
    * @param url
    * @param parameters
    * @param httpOptions
    * @returns
    */
   deleteRequest(url: string, body: any, httpOptions?: HttpOptionsInterface): Observable<unknown> {

      //console.log("BODY", body)
      let PARAMS = new HttpParams().set("raw", JSON.stringify(body))
      //console.log("PARAMS", PARAMS)

      const opt = { ...httpOptions, ...this.getAuthorizationHeader(), body: PARAMS };
      //console.log("delete options: ", opt);
      return this.http
         .delete(url, opt)
         .pipe(
            map((resp: any) => {
               // in caso di errore stampo un alert
               if (resp.error && resp.error !== 0) {
                  this.logger.error(`Errore postRequest`, resp);
               }

               // in ogni caso ritorno al response dell'API
               return resp;
            })
         )
         .pipe(
            catchError((error) => {
               return throwError(error);
            })
         );
   }

   loaderf = (function loadLayerSourceUrl(image, url: string) {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', 'Bearer ' + this.loginServ.getToken());

      xhr.addEventListener('loadend', function (evt) {

         const data = this.response;
         if (data !== undefined) {
            image.getImage().src = URL.createObjectURL(data);
         } else {
            image.setState(3);
         }
      });
      xhr.addEventListener('error', function () {
         image.setState(3);
      });

      xhr.send();
   }).bind(this);

}
